// @ts-nocheck
import { HistoryOutlined } from '@ant-design/icons';
import { Modal, Spin, Tabs } from 'antd';
import { useGetPCodeDeltaHistoryQuery } from 'services/pcodes/pcodes-api';
import styled from 'styled-components';
import getLocalTime from 'utils/get-local-time';
import PCodesDeltaTable from './pcodes-delta-table';

const MetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 12px 0;

  span {
    margin-left: auto;
  }

  span span {
    font-weight: bold;
    margin-right: 3px;
  }
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
  }
`;

export interface IPCodesDeltaHistoryModal {
  closeModal: () => void;
}

const PCodesDeltaHistoryModal = ({ closeModal }: IPCodesDeltaHistoryModal) => {
  const { data, isLoading, error } = useGetPCodeDeltaHistoryQuery();

  if (error) {
    <p>An error ocurred while getting the Pcode Delta history information.</p>;
  }

  const renderHistory = () => {
    if (isLoading) {
      return <Spin />;
    }
    if (!data || !Object.keys(data).length) {
      return <p>There is no history data available.</p>;
    }

    const keys = Object.keys(data);
    const lastKey = keys[keys.length - 1];

    const tabItems = Object.keys(data)
      .reverse()
      .map((key: string) => ({
        key,
        label: getLocalTime(
          data[key].pCodeFileMetaData.uploadedOn,
          'DD/MM/YYYY - HH:mm'
        ),
        children: (
          <>
            <MetaInfo>
              <span>
                <span>Uploaded By:</span>
                {data[key].pCodeFileMetaData.uploadedBy}
              </span>
            </MetaInfo>

            <PCodesDeltaTable deltaData={data[key].pCodeDeltas} />
          </>
        ),
      }));

    return (
      <StyledTabs
        defaultActiveKey={lastKey}
        tabPlacement="top"
        items={tabItems}
      />
    );
  };

  return (
    <Modal
      title={
        <>
          <HistoryOutlined /> Pcode history overview
        </>
      }
      open
      width={1400}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
    >
      {renderHistory()}
    </Modal>
  );
};

export default PCodesDeltaHistoryModal;
